import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { MenuIcon } from "lucide-react";

export const DashboardLogo = () => {
  const { toggleSidebar, open } = useSidebar();

  return (
    <div className="flex items-center gap-2 px-[5px]">
      <Button
        variant={"ghost"}
        size={"icon"}
        className={cn("rounded-full transition-all", {
          "rotate-180": open,
        })}
        onClick={toggleSidebar}
      >
        <MenuIcon className="w-5 h-5 scale-150" />
      </Button>
      {open ? (
        <div className="overflow-hidden delay-1000  ">
          <h1 className="text-2xl font-bold text-blackText block min-w-max">
            Simply Flow
          </h1>
        </div>
      ) : null}
    </div>
  );
};
